import { rankingData } from '@/mocks/homeData';

const rankColors: Record<number, string> = {
  1: 'bg-primary-500 text-background-50',
  2: 'bg-accent-500 text-background-50',
  3: 'bg-secondary-500 text-background-50',
};

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="mb-8 md:mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2">
            吃瓜热度榜
          </h2>
          <p className="text-sm text-foreground-500">实时追踪全网最热话题，热度数据每小时更新</p>
        </div>

        <div className="bg-background-50 rounded-2xl border border-background-200 overflow-hidden">
          {rankingData.map((item, i) => (
            <a
              key={item.rank}
              href="#cards"
              onClick={(e) => { e.preventDefault(); document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' }); }}
              className={`flex items-center gap-4 px-5 py-4 hover:bg-primary-50/50 transition-colors cursor-pointer ${i < rankingData.length - 1 ? 'border-b border-background-200' : ''}`}
            >
              <div className={`w-8 h-8 rounded-lg flex items-center justify-center text-sm font-bold flex-shrink-0 ${rankColors[item.rank] || 'bg-background-200 text-foreground-600'}`}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-medium text-foreground-900 line-clamp-1">{item.title}</h3>
              </div>
              <div className="flex items-center gap-3 flex-shrink-0">
                <div className="flex items-center gap-1">
                  {item.trend === 'up' && <i className="ri-arrow-up-line text-primary-500 text-xs" />}
                  {item.trend === 'down' && <i className="ri-arrow-down-line text-secondary-500 text-xs" />}
                  {item.trend === 'new' && <span className="text-[10px] px-1.5 py-0.5 rounded bg-accent-100 text-accent-700 font-medium whitespace-nowrap">NEW</span>}
                  <span className="text-xs font-medium text-foreground-600 whitespace-nowrap">{item.change}</span>
                </div>
                <span className="text-xs text-foreground-400 whitespace-nowrap min-w-[60px] text-right">{item.heat}热度</span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}